"use client";

import { Label } from "@/components/ui/label";
import CardField from "./cardField";
import { Input } from "@/components/ui/input";
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@/components/ui/select";
import { t } from "@/lib/localization";
import { useLocale } from "@/hooks/useLocale";

export default function CardFields({
    needsInvoice,
    showInstallments,
    installments,
    onInstallmentsChange,
    totalAmount,
}: {
    needsInvoice: boolean;
    showInstallments: boolean;
    installments: number;
    onInstallmentsChange: (n: number) => void;
    totalAmount: number;
}) {
    const { dir } = useLocale();

    return (
        <>
            <CardField
                id="credit_card_number"
                label={t("payments.card-fields.number")}
                className="flex flex-col w-full"
            />
            <div className="flex flex-row w-full gap-3">
                <CardField
                    id="expiry"
                    label={t("payments.card-fields.expiry")}
                    className="flex flex-col w-2/3"
                />
                <CardField
                    id="cvv"
                    label={t("payments.card-fields.cvv")}
                    className="flex flex-col w-1/3"
                />
            </div>
            {needsInvoice && (
                <div className="flex flex-row gap-3">
                    <div className="flex flex-col gap-1">
                        <Label>{t("payments.card-fields.invoice-name")}</Label>
                        <Input id="nameForInvoice" name="nameForInvoice" />
                    </div>
                    <div className="flex flex-col gap-1">
                        <Label>{t("payments.card-fields.company-id")}</Label>
                        <Input id="idForInvoice" name="idForInvoice" />
                    </div>
                </div>
            )}
            {showInstallments && (
                <div className="flex flex-col gap-1">
                    <Label>{t("payments.payment-form.installments")}</Label>
                    <Select
                        value={installments.toString()}
                        onValueChange={(v) => onInstallmentsChange(Number(v))}
                        dir={dir}
                    >
                        <SelectTrigger>
                            <SelectValue />
                        </SelectTrigger>
                        <SelectContent>
                            {Array.from(
                                {
                                    length: Math.min(
                                        10,
                                        Math.max(
                                            1,
                                            Math.floor(totalAmount / 50)
                                        )
                                    ),
                                },
                                (_, i) => i + 1
                            ).map((n) => (
                                <SelectItem key={n} value={n.toString()}>
                                    {n}
                                </SelectItem>
                            ))}
                        </SelectContent>
                    </Select>
                </div>
            )}
        </>
    );
}
